import { Fragment, h, JSX } from 'preact';

export interface ButtonOrLinkProps {
    button?: JSX.IntrinsicElements['button'];
    link?: JSX.IntrinsicElements['a'];
}

export const ButtonOrLink = (props: ButtonOrLinkProps): JSX.Element => (
    <Fragment>
        {props.button && <button {...props.button} />}
        {props.link && <a {...props.link} />}
    </Fragment>
);
